import React, { useEffect, useState } from "react";
import TopNavBar from "../../layouts/topNavBar";
import SideNavBar from "../../layouts/sideNavBar";
import { useLocation, useNavigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { uploadOriginalDoc } from "../../redux/Documents/doc.action";
import { useDispatch, useSelector } from "react-redux";
import mammoth from "mammoth";
import * as pdfjsLib from "pdfjs-dist/build/pdf";
import pdfWorker from "pdfjs-dist/build/pdf.worker.entry";
import DocFooter from "../../reusable_components/docFooter";
import Loader from "../../services/loader";
import DashboardSidebar from "./dashboardSidebar";

export default function Issuer() {
  pdfjsLib.GlobalWorkerOptions.workerSrc = URL.createObjectURL(
    new Blob([pdfWorker], { type: "application/javascript" })
  );

  pdfjsLib.GlobalWorkerOptions.workerSrc = pdfWorker;

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { state } = useLocation();
  const [isActive, setIsActive] = useState("");
  const [permission, setPermission] = useState("Private");
  const [isLoading, setIsLoading] = useState(false);

  const [selectMicrotext, setSelectMicrotext] = useState(false);
  const [selectWatermark, setSelectWatermark] = useState(false);
  const [previewImage, setPreviewImage] = useState(null); // New state for preview
  const [isPDF, setIsPDF] = useState(false);
  const [isImage, setIsImage] = useState(false);
  const [finalDocUrl, setFinalDocUrl] = useState(null);
  const [isConverting, setIsConverting] = useState(false);

  const store = useSelector((state) => state);

  const userNameStore = useSelector(
    (store) => store?.AuthManager?.userDetail?.userdetail?.name
  );

  const renderPDF = async (file) => {
    setFinalDocUrl(null);
    const pdfData = await file.arrayBuffer();
    const pdf = await pdfjsLib.getDocument({ data: pdfData }).promise;

    const pages = [];

    for (let i = 1; i <= pdf.numPages; i++) {
      const page = await pdf.getPage(i);
      const scale = 2;
      const viewport = page.getViewport({ scale });

      // Prepare canvas for rendering the PDF page
      const canvas = document.createElement("canvas");
      const context = canvas.getContext("2d");
      canvas.height = viewport.height;
      canvas.width = viewport.width;

      // Render the PDF page into the canvas context
      await page.render({ canvasContext: context, viewport }).promise;

      // Convert canvas to data URL
      const imgData = canvas.toDataURL();
      pages.push(imgData); // Store each page as an image
    }

    setPreviewImage(pages); // Set all pages as images
  };

  const renderWord = async (file) => {
    const arrayBuffer = await file.arrayBuffer();
    mammoth
      .convertToHtml({ arrayBuffer })
      .then((result) => {
        const html = result.value;
        setPreviewImage(html);
      })
      .catch((err) => {
        console.error("Error rendering Word document:", err);
      });
  };

  useEffect(() => {
    if (state) {
      const fileName = state.data1.file.name;
      if (fileName.endsWith(".pdf")) {
        setIsPDF(true);
        renderPDF(state.data1.file);
      } else if (fileName.endsWith(".docx") || fileName.endsWith(".doc")) {
        setIsImage(false);
        setIsPDF(false);
        renderWord(state.data1.file);
      } else {
        setPreviewImage(URL.createObjectURL(state.data1.file));
        setIsImage(true);
      }
    }
  }, [state]);

  useEffect(() => {
    if (state) {
      const value = state?.data1?.permission;
      value && setPermission(value);
    }
  }, [state]);

  const handleGenerate = () => {
    const payload = {};
    dispatch(
      uploadOriginalDoc(payload, (response) => {
        setIsLoading(true);
        const fileData = state.data1;
        // navigate only on success
        navigate("/final-submit", { state: { response, fileData } });
      })
    );
  };

  return (
    <main className="page-layout page-layout--dashboard">
      <TopNavBar />
      <article className="w-100 px-0 content-layout">
        <div className="mt-2 content-layout__inner">
          <SideNavBar />
          <div className="w-100 blurred-widget-block grid-side-section">
            <div className="grid-side-section__left">
              <div className="title-row">
                <h6 className="grayText fw500 fz14 text-uppercase mb-0 lh-1 step-num-label">
                  Step 3
                </h6>
                <h2 className="text-capitalize font-secondary fz34 fw800">
                  Final Document Preview
                </h2>
              </div>

              <div className="blurred-widget-block bdr-gray table-area">
                <div className="table-title-bar">
                  <div className="table-title-bar__left">
                    <h4 className="mb-0 lh1-5 font-secondary fz16 fw600">
                      Upload Documents
                    </h4>
                  </div>
                </div>
                <div className="table-responsive">
                  <table className="table mb-0 custom-dataTable">
                    <thead>
                      <tr>
                        <th>
                          <div className="fz12 fw400 grayText">
                            <img
                              src="/images/icons/icon-th-name.svg"
                              alt="Name"
                            />
                            <span>Name</span>
                          </div>
                        </th>
                        <th>
                          <div className="fz12 fw400 grayText">
                            <img
                              src="/images/icons/icon-th-type.svg"
                              alt="type"
                            />
                            <span>Type</span>
                          </div>
                        </th>
                        <th>
                          <div className="fz12 fw400 grayText">
                            <img
                              src="/images/icons/icon-calender.svg"
                              alt="calendar"
                            />
                            <span>Privacy Settings</span>
                          </div>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <span>
                            {state?.data1?.fileName?.name
                              ? state?.data1?.fileName?.name
                              : "NA"}
                          </span>
                        </td>
                        <td>
                          <div className="p-instructions">
                            {state?.data1?.fileName?.name
                              ?.split(".")
                              ?.pop()
                              ?.toLowerCase() === "jpg" ? (
                              <span className="text-uppercase text-center p-instructions__format fz10 fw600 text-white p-instructions__format--jpg">
                                .
                                {state?.data1?.fileName?.name?.split(".").pop()}
                              </span>
                            ) : state?.data1?.fileName?.name
                                ?.split(".")
                                .pop()
                                ?.toLowerCase() === "pdf" ? (
                              <span className="text-uppercase text-center p-instructions__format fz10 fw600 text-white p-instructions__format--png">
                                .
                                {state?.data1?.fileName?.name?.split(".").pop()}
                              </span>
                            ) : (
                              <span className="text-uppercase text-center p-instructions__format fz10 fw600 text-white p-instructions__format--docx">
                                .
                                {state?.data1?.fileName?.name?.split(".").pop()}
                              </span>
                            )}
                          </div>
                        </td>
                        <td>
                          <div className="dropdown">
                            <button
                              className={`border-0 p-0 btn dropdown-toggle select-privacy ${
                                isActive === "priv" ? "active" : ""
                              }`}
                              type="button"
                              data-bs-toggle="dropdown"
                              aria-expanded="false"
                            >
                              {isActive === "priv" ? (
                                <img
                                  src="/images/icons/icon-user-red.svg"
                                  alt=""
                                />
                              ) : permission === "Private" ? (
                                <img
                                  src="/images/icons/icon-user-red.svg"
                                  alt=""
                                />
                              ) : (
                                <img
                                  src="/images/icons/icon-multi-users-green-dark.svg"
                                  alt=""
                                />
                              )}
                              <span className="fz12">
                                {isActive === "priv"
                                  ? "Private"
                                  : permission
                                  ? permission
                                  : "Public"}
                              </span>
                              <img
                                className="ts03 arrow"
                                src="/images/icons/icon-table-dd-arrow.svg"
                                alt=""
                              />
                            </button>
                            <div className="blurred-widget-block bdr-gray blur-7 dropdown-menu dropdown-menu--privacy">
                            </div>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>

                  <div className="bottom-content-wrapper">
                    <div className="bottom-content">
                      {isConverting ? (
                        <div className="loader-wrapper">
                          <p>Loading preview...</p>
                        </div>
                      ) : finalDocUrl ? (
                        <div className="pdf-scroll-container">
                          {finalDocUrl.map((url, index) => (
                            <div className="pdf-page-container" key={index}>
                              <img
                                src={url}
                                alt={`Modified Page ${index + 1}`}
                              />
                              <DocFooter
                                presentOwner={userNameStore}
                                lastOwner="NA"
                              />
                            </div>
                          ))}
                        </div>
                      ) : isPDF ? (
                        // Original PDF Preview
                        <div className="pdf-scroll-container">
                          {previewImage?.length > 0 ? (
                            previewImage.map((page, index) => (
                              <div key={index} className="pdf-page-container">
                                <img
                                  src={page}
                                  alt={`PDF page ${index + 1}`}
                                  className="image-micotext"
                                />
                              </div>
                            ))
                          ) : (
                            <p>No pages to display.</p>
                          )}
                        </div>
                      ) : isImage ? (
                        <img
                          src={
                            state?.data1?.file?.name
                              ? URL.createObjectURL(state.data1.file)
                              : "path_to_placeholder_image"
                          }
                          alt="Uploaded file"
                          className="image-micotext"
                        />
                      ) : previewImage ? (
                        <div className="word-document-preview">
                          <div
                            className="a4-page"
                            dangerouslySetInnerHTML={{ __html: previewImage }}
                          />
                        </div>
                      ) : (
                        <div />
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <DashboardSidebar handleNext={handleGenerate} />
          </div>
        </div>
      </article>
      <ToastContainer />
      <Loader show={isLoading} />
    </main>
  );
}
